import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Spikes extends Modifier {
  static readonly baseTitle = 'Spikes';
  static readonly baseText =
    'When attacked, deal damage back to the attacker equal to stacks. Temporary.';
  static readonly baseIcon = 'spikes';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Spikes.baseTitle;
  text = Spikes.baseText;
  icon = Spikes.baseIcon;
  tags: Array<ModifierTags> = [...Spikes.baseTags];
  priority = Spikes.basePriority;

  damageIn(damage: Damage) {
    if (damage.source !== damage.target) {
      healthRemove({
        value: this.stacks,
        target: damage.source,
        source: damage.target,
        dice: [],
      });

      this.removeStacks(1);
    }
  }

  startTurn() {
    this.removeStacks(this.stacks);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Spikes, Spikes);
